// tslint:disable-next-line:no-var-requires
var realClassNames = require('classnames');
export var classNames = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return realClassNames.apply(void 0, classes);
};
//# sourceMappingURL=classnames.js.map